
function AccordionBlock() {
    for (let accordion of document.querySelectorAll('.accordion-block')) {
        let sections = accordion.querySelectorAll('.section');
        console.log("Accordioning ", accordion, sections);
        let activeSection = null;
        let activePanel = null;
        for (let section of sections) {
            let tab = section.querySelector('button');
            let panel = section.querySelector('.panel');
            console.log(tab, panel);
            tab.addEventListener('click', function() {
                if (activeSection === section) {
                    section.classList.remove('expanded');
                    section.classList.add('collapsed');
                    let animation = section.animate([
                        { maxHeight: `${section.getBoundingClientRect().height}px`, overflowY: 'clip', },
                        { maxHeight: `${tab.getBoundingClientRect().height}px`, overflowY: 'clip' },
                    ], { duration: 350, easing: 'ease' });
                    animation.addEventListener('finish', function() {
                        panel.setAttribute('hidden', 'hidden');
                    });
                    activeSection = null;
                    activePanel = null;
                }
                else {
                    if (activeSection !== null) {
                        let section = activeSection;
                        let panel = activePanel;
                        section.classList.remove('expanded');
                        section.classList.add('collapsed');
                        let animation = section.animate([
                            { maxHeight: `${section.getBoundingClientRect().height}px`, overflowY: 'clip', },
                            { maxHeight: `${tab.getBoundingClientRect().height}px`, overflowY: 'clip' },
                        ], { duration: 350, easing: 'ease' });
                        animation.addEventListener('finish', function() {
                            panel.setAttribute('hidden', 'hidden');
                        });
                    }
                    section.classList.add('expanded');
                    section.classList.remove('collapsed');
                    panel.removeAttribute('hidden');
                    section.animate([
                        { maxHeight: `${tab.getBoundingClientRect().height}px`, overflowY: 'clip' },
                        { maxHeight: `${section.getBoundingClientRect().height}px`, overflowY: 'clip', },
                    ], { duration: 350, easing: 'ease' });
                    activeSection = section;
                    activePanel = panel;
                }
            });
        }
    }
}

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', AccordionBlock);
}
else {
    AccordionBlock();
}
